
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { htmlVisualElement } from '../html/visual-element.mjs.js';
import { svgVisualElement } from '../svg/visual-element.mjs.js';
import { isSVGComponent } from './utils/is-svg-component.mjs.js';

var createDomVisualElement = function (Component, options) {
    return isSVGComponent(Component)
        ? svgVisualElement(options, { enableHardwareAcceleration: false })
        : htmlVisualElement(options, { enableHardwareAcceleration: true });
};

export { createDomVisualElement };
//# sourceMappingURL=create-visual-element.mjs.js.map
